export default __webpack_public_path__ + "static/media/Cabezal.215639ba.jpg";